import './Auth.scss';
import { ReactElement } from 'react';
import { AuthContainer } from '../../modules/auth/containers/AuthContainer';
import { RequestResetPasswordContainer } from '../../modules/auth/containers/RequestResetPasswordContainer';

export const ForgotPasswordView = (): ReactElement => (
  <AuthContainer>
    <RequestResetPasswordContainer />
  </AuthContainer>
);
